import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ServiceFormContextType {
  isOpen: boolean;
  selectedService: string;
  scrollPosition: number;
  openForm: (serviceName: string) => void;
  closeForm: () => void;
}

const ServiceFormContext = createContext<ServiceFormContextType | undefined>(undefined);

interface ServiceFormProviderProps {
  children: ReactNode;
}

export const ServiceFormProvider: React.FC<ServiceFormProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedService, setSelectedService] = useState('');
  const [scrollPosition, setScrollPosition] = useState(0);

  const openForm = (serviceName: string) => {
    console.log('=== OPENFORM CALLED ===');
    console.log('Service:', serviceName);
    console.log('Current scroll in openForm:', window.scrollY);
    console.log('Current URL in openForm:', window.location.href);
    
    // Store current scroll position before opening popup
    const scrollY = window.scrollY;
    
    console.log('Setting selected service, scroll position, and isOpen...');
    setScrollPosition(scrollY);
    setSelectedService(serviceName);
    setIsOpen(true);
    
    // Stop any smooth scrolling behavior immediately
    document.documentElement.style.scrollBehavior = 'auto';
    
    console.log('=== OPENFORM END ===');
  };

  const closeForm = () => {
    setIsOpen(false);
    setSelectedService('');
    // Keep scroll position until popup is fully closed
    
    // Restore normal scroll behavior
    document.documentElement.style.scrollBehavior = 'auto';
  };

  return (
    <ServiceFormContext.Provider value={{ isOpen, selectedService, scrollPosition, openForm, closeForm }}>
      {children}
    </ServiceFormContext.Provider>
  );
};

export const useServiceForm = () => {
  const context = useContext(ServiceFormContext);
  if (context === undefined) {
    throw new Error('useServiceForm must be used within a ServiceFormProvider');
  }
  return context;
};
